import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'Use Cases',
    href: '#use-cases'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="w-full bg-slate-900 sticky top-0 z-50 shadow-lg border-b border-slate-800" data-id="element-329">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-330">
        <div className="flex items-center" data-id="element-331">
          <Link to="/" data-id="element-332">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KuE4GiXagr4eVmupSGvce/fluid-form-logo.png" alt="FluidForm Logo" className="h-8" data-id="element-333" />
          </Link>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-334">
          {navItems.map((item, index) => item.isRouterLink ? <Link key={index} to={item.href} className="text-slate-300 hover:text-orange-500 transition-colors" data-id="element-335">
                {item.name}
              </Link> : <a key={index} href={item.href} className="text-slate-300 hover:text-orange-500 transition-colors" data-id="element-336">
                {item.name}
              </a>)}
          <a href="https://accounts.fluid-form.ai/sign-in" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-orange-500 transition-colors border border-slate-700 px-4 py-2 rounded-md hover:border-orange-500" data-id="element-337">
            Login
          </a>
          <a href="https://cal.com/fluidform/30min" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-2 rounded-md hover:from-orange-600 hover:to-orange-700 transition-all" data-id="element-338">
            Sign Up
          </a>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden text-slate-300" onClick={() => setIsOpen(!isOpen)} data-id="element-339">
          {isOpen ? <XIcon size={24} data-id="element-340" /> : <MenuIcon size={24} data-id="element-341" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden bg-slate-900 border-t border-slate-800" data-id="element-342">
          <div className="container mx-auto px-4 py-2 flex flex-col space-y-3" data-id="element-343">
            {navItems.map((item, index) => item.isRouterLink ? <Link key={index} to={item.href} className="text-slate-300 py-2 hover:text-orange-500 transition-colors" data-id="element-344">
                  {item.name}
                </Link> : <a key={index} href={item.href} className="text-slate-300 py-2 hover:text-orange-500 transition-colors" data-id="element-345">
                  {item.name}
                </a>)}
            <a href="https://accounts.fluid-form.ai/sign-in" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-orange-500 transition-colors border border-slate-700 px-4 py-2 rounded-md text-center hover:border-orange-500" data-id="element-346">
              Login
            </a>
            <a href="https://cal.com/fluidform/30min" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-2 rounded-md hover:from-orange-600 hover:to-orange-700 transition-all text-center" data-id="element-347">
              Sign Up
            </a>
          </div>
        </div>}
    </header>;
};
export default Navbar;